<template>
    <div class="query-box">
        <div class="query-form" ref="queryform" :style="{ 'height': isexpand ? 'auto' : '46px' }">
            <slot></slot>
        </div>
        <div class="line"></div>
        <div class="btn-group">
            <div>
                <slot name="footer"></slot>
            </div>
            <div class="expand-btn" v-if="showexpand" @click="isexpand = !isexpand"><span>{{ isexpand ? '收起' : '展开'
            }}</span>
                <local-svg :class="{ 'expand': isexpand }" iconClass="showdown"></local-svg>
            </div>
        </div>
    </div>
</template>
 
<script>
let timer = null;
export default {
    data() {
        return {
            isexpand: false,
            showexpand: false,
        }
    },
    methods: {
        judgeIsShow() {
            let dom = this.$refs.queryform;
            if (dom) {
                // console.log('dom.clientHeight',dom.scrollHeight , dom.clientHeight);
                if (dom.scrollHeight > 46) {
                    this.showexpand = true
                } else {
                    this.showexpand = false
                }
            }
        },
        debounceFun() {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                this.judgeIsShow()
            }, 500)
        }

    },
    mounted() {
        this.judgeIsShow()
        window.addEventListener('resize', this.debounceFun)
    },
    destroyed() {
        window.removeEventListener('resize', this.debounceFun)
    }
}
</script>
 
<style scoped lang="scss">
.query-box {
    background: #FFFFFF;
    border-radius: 6px 6px 6px 6px;
    flex: none;
    overflow: hidden;

    .query-form {
        margin: 9px 24px;
        overflow: hidden;
        box-sizing: border-box;

        :deep(.el-form-item) {
            margin: 7px 20px 7px 0 !important;
            height: 32px !important;
        }

        :deep(.select-line) {
            display: flex !important;
            flex-wrap: wrap !important;
            padding: 0 !important;
        }

        :deep(.el-form-item__label) {
            line-height: 32px;
            padding: 0 12px 0 0 !important;
        } 

        :deep(.bostrap){
            height: auto!important;
        }
    }

    .line {
        height: 1px;
        width: 100%;
        background: #F0F1F5;
    }

    .btn-group {
        height: 56px;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        :deep(.el-button+.el-button){
            margin-left: 12px;
        }
        :deep(button+button){
            margin-left: 12px;
        }
    }

    .expand-btn {
        cursor: pointer;
        color: #3F5A8B;
        display: flex;
        align-items: center;

        &:hover {
            color: #1D78FE;
        }

        span {
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            margin-right: 1px;
        }

        .svg-icon {
            font-size: 16px;
            margin-right: -5px;

            &.expand {
                transform: rotateZ(180deg);
            }
        }
    }
}
</style>